import { URL } from '../../../../config'
import { getRequest } from '../../../../utils/httpRequest'

export const getParticipants = function (eventId,token) 
{
  const participantEndpoint = `/${eventId}/participants`
  const  participantURL     =  `${URL.postevent}${participantEndpoint}` 
  return getRequest(participantURL,'json',token)
}


// WEBPACK FOOTER //
// ./src/components/pages/Event/api/getParticipants.js